import { getTranslateByKey, isNullUndefinedEmpty } from '@/main/services/utils';
import * as S from './styles';
import LoadingComponent from '@/main/components/shared/loading/loadingComponent';
import { useEffect, useState } from 'react';
import {
  CompanyHistoricalDetailItemResponse,
  CompanyHistoricalResponse
} from '@/main/models/response/companyHistoricalResponse';
import KogModalSideComponent from '@/main/components/modal/ModalSide';
import { firstLetterToUpperCase } from '@/main/services/utilsString';
import SecondaryButton from '@/main/components/shared/button/secondaryButton';
import { companyHistoricalApi } from '@/main/api';
import { CompanyHistoricalDetailsRequest } from '@/main/models/request/companyHistoricalRequest';
import { ChangeJustificationResponse } from '@/main/models/response';
import { downloadFile } from '@/main/services/utilsFile';

interface Props {
  open: boolean;
  closeModal: () => void;
  itemSelected: CompanyHistoricalResponse;
}

export default function CompanyHistoricalSidebarDetails({
  open,
  itemSelected,
  closeModal
}: Props) {
  const [isLoadingInfo, setIsLoadingInfo] = useState<boolean>(true);
  const [details, setDetails] = useState<CompanyHistoricalDetailItemResponse[]>(
    []
  );
  const [changeJustification, setChangeJustification] = useState<ChangeJustificationResponse | undefined>(
    undefined
  );

  useEffect(() => {
    if (open) {
      setIsLoadingInfo(true);

      const request: CompanyHistoricalDetailsRequest = {
        guidCompanyHistorical: itemSelected.guid
      };
      companyHistoricalApi
        .getHistoricalDetails(request)
        .then(response => {
          const resultData = response.data.result;
          setDetails(resultData?.details || []);
          setChangeJustification(resultData?.changeJustification);
        })
        .catch(() => {})
        .finally(() => {
          setIsLoadingInfo(false);
        });
    }
  }, [itemSelected.guid]);

  function handleDownloadFile(guidFileImport: string, fileName: string) {
    companyHistoricalApi
      .downloadHistoricalFile(guidFileImport)
      .then((response: any) => {
        if (response.data.result) {
          const base64File = response.data.result;
          downloadFile(base64File, fileName);
        }
      })
      .catch(() => {});
  }

  function renderValues(value: string, item: CompanyHistoricalDetailItemResponse) {
    if (item.isColor) {
      return <S.ColorBox color={value} />;
    }

    return value;
  }

  return (
    <>
      <KogModalSideComponent
        open={open}
        closeModal={() => {
          (closeModal(), setDetails([]), setChangeJustification(undefined));
        }}
        title={getTranslateByKey('information.historyDetails')}
        id="id-companyHistorical--details-modal-scroll">
        <S.AccordionContainer>
          <S.AccordionTitle>{`${itemSelected.actionName} - ${itemSelected.userCompany}`}</S.AccordionTitle>
          {!isLoadingInfo ? (
            <>
              <S.AccordionDetailsHistory>
                {details &&
                  details.map((item, indexItem) => (
                    <S.BoxLabelItem key={indexItem}>
                      <S.ContainerLabel>
                        <S.LabelItem>
                          {firstLetterToUpperCase(
                            `${getTranslateByKey('SupplierInventoryHistory.field')}:`
                          )}
                        </S.LabelItem>
                        <S.LabelResult>{item.field}</S.LabelResult>
                      </S.ContainerLabel>
                      <S.ContainerLabel>
                        <S.LabelItem>{`${getTranslateByKey('information.from')}:`}</S.LabelItem>
                        <S.LabelResult
                          style={{
                            alignItems: item.isColor ? 'center' : undefined
                          }}>
                          {renderValues(item.from, item)}
                        </S.LabelResult>
                      </S.ContainerLabel>
                      <S.ContainerLabel
                        style={{
                          alignItems: item.isColor ? 'center' : undefined
                        }}>
                        <S.LabelItem>{`${getTranslateByKey('information.to')}:`}</S.LabelItem>
                        <S.LabelResult>
                          {renderValues(item.to, item)}
                        </S.LabelResult>
                      </S.ContainerLabel>
                    </S.BoxLabelItem>
                  ))}
              </S.AccordionDetailsHistory>

              {changeJustification && (changeJustification.reason || changeJustification.reasonDescription || (changeJustification.files && changeJustification.files.length > 0)) && (
                <S.AccordionDetailsHistory style={{ marginTop: 16 }}>
                  {changeJustification.reason && (
                    <S.ContainerLabel style={{ marginBottom: 8 }}>
                      <S.LabelItem>{`${getTranslateByKey('information.reason')}:`}</S.LabelItem>
                      <S.LabelResult>{changeJustification.reason}</S.LabelResult>
                    </S.ContainerLabel>
                  )}
                  {changeJustification.reasonDescription && (
                    <S.ContainerLabel style={{ marginBottom: 8 }}>
                      <S.LabelItem>{`${getTranslateByKey('information.description')}:`}</S.LabelItem>
                      <S.LabelResult>{changeJustification.reasonDescription}</S.LabelResult>
                    </S.ContainerLabel>
                  )}
                  {changeJustification && !isNullUndefinedEmpty(changeJustification.files) && changeJustification.files.length > 0 && (
                    <S.ContainerLabel style={{ marginBottom: 8 }}>
                      <S.LabelItem>{`${getTranslateByKey('information.files')}:`}</S.LabelItem>
                      <S.LabelResult>
                        {changeJustification.files.map((file, idx) => (
                          <span key={idx}>
                            <S.FileLink
                              onClick={() => handleDownloadFile(file.guidFileImport, file.fileImportName)}
                            >
                              {file.fileImportName}
                            </S.FileLink>
                            {idx < changeJustification.files.length - 1 && <span style={{ color: '#000', marginRight: 4 }}>,</span>}
                          </span>
                        ))}
                      </S.LabelResult>
                    </S.ContainerLabel>
                  )}
                </S.AccordionDetailsHistory>
              )}
            </>
          ) : (
            <LoadingComponent />
          )}
        </S.AccordionContainer>
        <div
          className="d-flex justify-content-center"
          style={{ marginTop: 10 }}>
          <SecondaryButton
            id="id-companyType-historical-button-back"
            onClick={() => closeModal()}>
            {getTranslateByKey('information.back')}
          </SecondaryButton>
        </div>
      </KogModalSideComponent>
    </>
  );
}
